// data/cardSlideData.js
export const cards = [
    { id: 1, title: "Drive Store Sales <br /> Boost Recognition",
      content: "Sell to active Dev-Kitchen Customers & grow your store.",
      buttonText: "Get Started",
      route: "/vendor/signup" },
      
      {
        id: 2,
        title: "Profile",
        content: "Showcase your unique offerings and create a profile that attracts customers to your store. Let’s help you stand out!",
        buttonText: "Learn More",
        route: "/vendor/profile"
      },
      

    { id: 3, title: "Menu",
      content: "Make your meals stand out by showcasing your unique dishes! Attract more customers by adding delicious details and vibrant images",
      buttonText: "Add Meals",
      route: "/vendor/addmenu" },

    { id: 4, title: "Payout",
      content: "Stay on top of your sales with instant insights and seamless payouts. Track your earnings, review detailed stats, and manage all your transactions with ease. Your payout, your way – right at your fingertips.",
      buttonText: "Explore Your Payouts",
      route: "/vendor/payout" },
      
      { 
        id: 5, 
        title: "Unlock Insights", 
        content: "Gain valuable insights into your store's performance and customer behavior. Stay ahead of the curve with data-driven decisions that drive growth.",
        buttonText: "Explore Insights", 
        route: "/vendor/insight" 
      }
      
  ];
  